import { IsUUID, IsString, IsOptional } from "class-validator";

export default class PositionOrigin {
  @IsUUID("4")
  public readonly id!: string | null;

  @IsString()
  public name: string = "";
}
